import React from 'react'
import { Image } from 'semantic-ui-react'
import appHomeImage from '../Resources/images/payroll_home.png'

const Home = () => {
  return (
    <div>
      <Image src={appHomeImage} alt="app-home" size="medium" style={{margin: 'auto'}} />
      <h1 style={{textAlign: "center"}}>Welcome to Payroll Application</h1>
      {/* <InputFloated /> */}
    </div>
  )
}

export default Home